import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
// import logo from './Images/aman logo.png';

function Footer() {
    const startYear = 2025; // jo year se site start hui
    const currentYear = new Date().getFullYear();



    return (
        <footer className="footer">
            <div className="footer-container">
                {/* About Section */}
                <div className="footer-section about">
                    {/* <img src= {logo} alt="Logo" className="footer-logo" /> */}
                    <p>
                     Global Link Corporation (GLC) is a trusted import-export company connecting industries worldwide with reliable trade solutions. We specialize in delivering quality products, building strong partnerships, and enabling global growth through seamless logistics.                    </p>
                </div>

                {/* Links Section */}
                <div className="footer-section links">
                    <div className='CompanyCenter'>
                        <h3>Quick Links</h3>
                        <ul>
                           

                            <li><Link to="/AboutUs">About Us</Link></li>
                            <li><Link to="/search">Our Products</Link></li>
                            <li><Link to="/TermsAndcondition">Terms & Conditions</Link></li>
                            <li><Link to="/PrivacyPolicy">Privacy Policy</Link></li>
                            <li><Link to="/Gallery">Gallery</Link></li>


                            <li>
                                <Link to={{ pathname: "/contact" }} state={{ scrollTo: "form" }}>
                                    Contact Us
                                </Link>
                            </li>

                        </ul>
                    </div>
                </div>

                {/* Contact Section */}
                <div className="footer-section contact">
                    <div className='ContactUsCenter'>
                        <h3>Contact Us</h3>
                        <h6>
                            <i className="fas fa-envelope"></i>{' '}
                            <a href="mailto:Info@globallinkcorporation.com" target="_blank" rel="noopener noreferrer">
                                Info@globallinkcorporation.com
                            </a>
                        </h6>
                        <h6>
                            <i className="fas fa-phone"></i>{' '}
                            <a href="tel:+917405649537">
                                +91-7405649537
                            </a>
                        </h6>
                        <h6>
                            <i className="fab fa-whatsapp"></i>{' '}
                            <a href="https://wa.me/917405649537" target="_blank" rel="noopener noreferrer">
                                +91-7405649537
                            </a>
                        </h6>
                        <h6>
                            <i className="fas fa-map-marker-alt"></i>{' '}
                            <a
                                href="https://www.google.com/maps/search/?api=1&query=Platinum+Plaza,+F-5,+nr.+New+Lions+School,+Ankleshwar+GIDC,+Ankleshwar,+Gujarat+393001"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Platinum Plaza, F-5, nr. New Lions School, Ankleshwar GIDC, Ankleshwar, Gujarat 393001
                            </a>
                        </h6>

                    </div>
                </div>

                {/* Social Media Section */}
                <div className="footer-section social">
                    <div className='FollowCenter'>
                        <h3>Follow Us</h3>
                        <div className="social-icons">
                            <a href="https://www.instagram.com/globallinkcorporation?igsh=MWJmbDlleGFya2tzbQ==" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-instagram"></i>
                            </a>
                            <a href="https://www.linkedin.com/company/global-link-corporation" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-linkedin-in"></i>
                            </a>
                            <a href="https://wa.me/917405649537" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-whatsapp"></i>
                            </a>
                            <a href="https://x.com/globalinkcorp?s=11" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-twitter"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Copyright */}


            <div className="footer-bottom">
                &copy; {startYear}
                {currentYear > startYear ? ` - ${currentYear}` : ""}{" "}
                <strong>Global Link Corporation.</strong> All rights reserved. Website Design & Development by{" "}
                <a href="https://www.aptechsolution.com" target="_blank" rel="noopener noreferrer">
                    <strong>A.P Tech Solution</strong>
                </a>
            </div>




           

        </footer>
    );
}

export default Footer;
